/** Generic CSV export utility.
 * exportCsv(rows, columns, filename)
 *   rows: array of objects
 *   columns: array of { key, label, format? }
 */
export function exportCsv(rows, columns, filename = "export.csv") {
  const headers = columns.map((c) => c.label);
  const body = rows.map((r) =>
    columns.map((c) => {
      const v = c.format ? c.format(r[c.key], r) : r[c.key];
      return v === null || v === undefined ? "" : String(v);
    })
  );
  const csv = [headers, ...body]
    .map((row) => row.map((cell) => `"${(cell ?? "").toString().replace(/"/g, '""')}"`).join(","))
    .join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
